import React from 'react'
import SVG from 'react-inlinesvg'
import icon from '@icons/notice/blue'

const Notice = (props) => {
  return (
    <div className="notification">
      <SVG className="notification__icon" src={icon} />
      <div className="notification__wrapper">
        <h2 className="notification__title">{ props.title }</h2>
        <div className="notification__content">{ props.children }</div>
      </div>
    </div>
  )
}

export default Notice
